import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Select } from '@ngxs/store';
import { UserSandbox } from '../../../shared/sandbox/providers/user.sandbox';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { BioSealStateModel } from '../../../shared/model/bioseal.model';
import { GlobalSandbox } from '../../../shared/sandbox/providers/global.sandbox';
import { BioSealState } from '../../../shared/store/state/bioseal.state';
import { opening, closing, basketball, aviron } from './events';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'event-user-form',
  templateUrl: './event-user-form.component.html',
  styleUrls: ['./event-user-form.component.css'],
  providers: [UserSandbox, GlobalSandbox]
})
export class EventUserFormComponent {

  @Select(BioSealState.isEventFormSubmitted) eventSubmitted: Observable<BioSealStateModel>;
  @Select(BioSealState.isPersonalFormSubmitted) personalSubmitted: Observable<BioSealStateModel>;
  @Select(BioSealState.isEventDataLoaded) eventData: Observable<BioSealStateModel>;
  @Select(BioSealState.isPersonalDataLoaded) personalData: Observable<BioSealStateModel>;

  PersonalForm;
  EventForm;
  accreditation = false;

  @Output() nextEvent = new EventEmitter<boolean>();
  @Output() previousEvent = new EventEmitter<boolean>();

  get function() {
    return this.PersonalForm.get("function");
  }

  constructor(private formBuilder: FormBuilder, public userSandbox: UserSandbox, public globalSandbox: GlobalSandbox) {

    this.PersonalForm = this.formBuilder.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      function: ["", Validators.required]
    });
    this.PersonalForm.statusChanges.subscribe(() =>
      this.userSandbox.onPersonalFormValid({
        data: this.PersonalForm.value,
        validation: this.PersonalForm.valid,
      })
    );

    this.EventForm = this.formBuilder.group({
      eventName: ["", Validators.required],
      eventDate: ["", Validators.required],
      eventAddress: ["", Validators.required],
      eventTime: ["", Validators.required],
      parkingAcc: [""],
      grandstandAcc: [""],
      pressAcc: [""],
      vipAcc: [""],
      cloakroomAcc: [""],
      restaurantAcc: [""]
    });
    this.EventForm.statusChanges.subscribe(() => {
      this.userSandbox.onEventFormValid({
        data: this.EventForm.value,
        validation: this.EventForm.valid,
      })
    }
    );

  }

  async autoFill() {
    let eventSelected;
    const eventName = this.EventForm.get("eventName").value;
    switch (eventName.charAt(0)) {
      case '0':
        eventSelected = opening;
        break;
      case '1':
        eventSelected = basketball;
        break;
      case '2':
        eventSelected = aviron;
        break;
      case '3':
        eventSelected = closing;
        break;
      default:
        break;

    }

    this.EventForm = this.formBuilder.group({
      eventName: [eventName, Validators.required],
      eventDate: [eventSelected.date, Validators.required],
      eventAddress: [eventSelected.address, Validators.required],
      eventTime: [eventSelected.time, Validators.required],
      parkingAcc: [""],
      grandstandAcc: [""],
      pressAcc: [""],
      vipAcc: [""],
      cloakroomAcc: [""],
      restaurantAcc: [""]
    });
    this.EventForm.statusChanges.subscribe(() => {
      this.checkAccreditations();
      this.userSandbox.onEventFormValid({
        data: this.EventForm.value,
        validation: this.EventForm.valid,
      })
    }
    );

  }

  onPersonalSubmit(): void {
    this.personalData.pipe(take(1)).subscribe((loaded) => {
      loaded ? this.nextEvent.emit() : this.userSandbox.onPersonalFormSubmitted();
    });
  }

  onEventSubmit(): void {
    this.accreditation = this.checkAccreditations();
    this.eventData.pipe(take(1)).subscribe((loaded) => {
      loaded ? this.nextEvent.emit() : this.userSandbox.onEventFormSubmitted();
    });
  }

  changeFunction(e): void {
    this.function.setValue(e.target.value, {
      onlySelf: true,
    });
  }

  checkAccreditations(): boolean {
    return (this.EventForm.get("parkingAcc").value !== ''
      || this.EventForm.get("grandstandAcc").value !== ''
      || this.EventForm.get("pressAcc").value !== ''
      || this.EventForm.get("vipAcc").value !== ''
      || this.EventForm.get("cloakroomAcc").value !== ''
      || this.EventForm.get("restaurantAcc").value !== '');
  }

  previous(): void {
    this.previousEvent.emit();
  }

  next(): void {
    this.nextEvent.emit();
  }

}
